import React from "react";

interface Props {
    tableHeader:any[];
}
const Tableheader = ({ tableHeader = [] }:Props) => {
    return (
        <tr>
            {
                tableHeader.map((item, index) => {       
                    if (item){
                        return (
                            <th key={index}>
                                {item.label}
                            </th>
                        )
                    }else {
                        return null
                    }
                })
            }
            <th style={{width:'80px'}}></th>
        </tr>
    )
}

export default Tableheader;
